export const ShipmentTypesEnum = {
	CARRY: 'Mitnahme',
	POST: 'Post',
	EMAIL: 'Print@Home',
	PICKUP: 'Abholung',
};

export default ShipmentTypesEnum;
